import { Pipe, PipeTransform } from '@angular/core';

import { FileTypes } from './local-import.enum';

@Pipe({ name: 'fileImg', pure: true })
export class FileImgPipe implements PipeTransform {
  public transform(value: string): string {
    const splitValue = value.split('.');
    const extension = splitValue[splitValue.length - 1];

    if (extension === FileTypes.Dcm) {
      return 'radiology-scan';
    }

    const typesValues = Object.values(FileTypes);

    if (typesValues.find(value => value === extension)) {
      return 'image-picture-square';
    }

    return 'document-file-blank';
  }
}
